module.exports = __webpack_public_path__ + "img/96.2.TN.82bd83bd.png";